import { Reservations } from '../api';

export type CostCenterFieldConfiguration = Reservations.CostCenterFieldConfigurationModel;
export type CostCenterType = Reservations.CostCenterType;
export const CostCenterType = Reservations.CostCenterType;